import {useState} from 'react'
import {observer} from 'mobx-react'
import {i18n} from '../../../i18n'
import {sharedStyles} from '../../../style/shared_styles'
import {CustomModal, TitleText} from '../../common'
import {Button, Divider} from 'antd'
import EditDetailsEntry from '../../patient/components/subcomponents/EditDetailsEntry'
import {OrganizationAddressDto, OrganizationDto, ProfileDto} from '../../../utils/types'
import ChangePassword from './ChangePassword'
import { ConfigTypes } from '../../../utils/enums'

/**
 * Component used to display user data.
 */
const ProfileViewTab = observer((props: ProfileViewTabProps) => {
    const [changePassVisible, setChangePassVisible] = useState(false)

    const fullName = props.userProfile.firstName + ' ' + props.userProfile.lastName

    const getOrganization = (): OrganizationDto | null => {
        return props?.userProfile?.organizations?.[0] ?? null;
    }

    const getOrganizationAddress = (): OrganizationAddressDto | null => {
         const organization = props?.userProfile?.organizations?.[0];
         if(organization) {
            return organization.organizationAddresses?.[0] ?? null;
         }

         return null
    }


    return (
        <div>
            {/*-----------TITLE---------------------*/}
            <div style={{width: '98%', marginRight: 10}}>
                <div style={sharedStyles.inlineContainer}>
                    <TitleText size={20} text={i18n.t('profile.title')} />
                    {/*Edit Profile Button*/}
                    {/*<EditFilled style={{fontSize: 30}} onClick={() => setEditModalVisible(true)} />*/}
                </div>
                <Divider />
            </div>

            <div style={{display: 'flex'}}>
                {/*-----------Left Column---------------------*/}
                <div style={sharedStyles.leftColumn}>
                    <EditDetailsEntry title={i18n.t('userDataTab.profile.title')} value={props.userProfile.jobTitle} />
                    <EditDetailsEntry title={i18n.t('userDataTab.general.name')} value={fullName} />
                    <EditDetailsEntry title={i18n.t('userDataTab.contact.phone')} value={props.userProfile.phone} />
                    <EditDetailsEntry
                        title={i18n.t('userDataTab.contact.mail')}
                        value={<a href={`mailto:${props.userProfile.eMail}`}>{props.userProfile.eMail}</a>}
                    />
                    <EditDetailsEntry
                        title={i18n.t('profile.edit.password')}
                        value={
                            <Button type={'link'} size={'small'} style={{paddingLeft: 0}} onClick={() => setChangePassVisible(true)}>
                                {i18n.t('profile.edit.changePass')}
                            </Button>
                        }
                    />

                    <EditDetailsEntry
                        title={i18n.t('userDataTab.general.role')}
                        value={i18n.t(`userDataTab.role.${props.userProfile.doctor ? 'doctor' : 'nurse'}`)}
                    />
                </div>

                {/*-----------Right Column---------------------*/}
                <div style={sharedStyles.rightColumn}>
                    <EditDetailsEntry title={i18n.t('userDataTab.profile.hospital')} value={getOrganization()?.name} />
                     <EditDetailsEntry title={i18n.t('userDataTab.profile.department')} value={props.userProfile.department} />
                    <EditDetailsEntry title={i18n.t('userDataTab.contact.street')} value={getOrganizationAddress()?.street} />
                     <EditDetailsEntry title={i18n.t('userDataTab.contact.postalCode')} value={getOrganizationAddress()?.zip}  />
                     <EditDetailsEntry title={i18n.t('userDataTab.contact.city')} value={getOrganizationAddress()?.city}  />
                     <EditDetailsEntry title={i18n.t('userDataTab.insurance.ikSign')} value={props.userProfile.ikSign} />
                </div>
            </div>
            <CustomModal title={i18n.t('profile.changePass.title')} open={changePassVisible}>
                <ChangePassword closeModal={() => setChangePassVisible(false)} />
            </CustomModal>
        </div>
    )
})

type ProfileViewTabProps = {
    userProfile: ProfileDto
     userConfig: Map<ConfigTypes, any> | null | undefined
}

export default ProfileViewTab
